import { Button, Checkbox, Col, Form, Input, Modal, Row, message } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateMake } from "../../../../api/makes";
import { useEffect, useState } from "react";

const UpdateMake = ({ isVisible, setVisible, selected }: any) => {
  const { id } = selected;
  const queryClient = useQueryClient();
  const [isActive, setActive] = useState<boolean>(selected?.is_active);

  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation({
    mutationFn: updateMake,
    onError: (error) => {
      message.error(`${error}`);
    },
    onSuccess: () => {
      message.success("Updated Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["makes"] });
      setVisible(false);
    },
  });

  const onSubmit = async () => {
    const { name, count } = await form.validateFields();
    const data = { name, is_active: isActive, count: Number(count) };
    mutate({ id, data });
  };

  useEffect(() => {
    form.setFieldsValue({ ...selected });
    setActive(selected?.is_active);
  }, [selected]);

  return (
    <>
      <Modal
        title="Update Make"
        open={isVisible}
        onCancel={() => setVisible(false)}
        footer={[
          <Button key="back" onClick={() => setVisible(false)}>
            Cancel
          </Button>,
          <Button
            key="submit"
            form="updateMake"
            htmlType="submit"
            onSubmit={onSubmit}
            loading={isLoading}
            className="border-0 bg-blue-600 text-white"
          >
            Submit
          </Button>,
        ]}
      >
        <Form
          id="updateMake"
          form={form}
          name="control-ref"
          onFinish={onSubmit}
          layout="vertical"
        >
          <Row gutter={[16, 0]}>
            <Col xs={{ span: 24 }} lg={{ span: 12 }}>
              <Form.Item
                name="name"
                label="Make Name"
                initialValue={selected?.name}
                rules={[
                  {
                    required: true,
                    message: "Please enter make name",
                  },
                ]}
              >
                <Input placeholder="Make Name" />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} lg={{ span: 12 }}>
              <Form.Item
                name="count"
                label="Vehicles Count"
                initialValue={selected?.name}
                rules={[
                  {
                    required: true,
                    message: "Please enter vehicle count",
                  },
                ]}
              >
                <Input placeholder="Vehicles Count" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 0]}>
            <Col xs={{ span: 24 }} lg={{ span: 12 }}>
              <Checkbox
                defaultChecked={selected?.is_active}
                onChange={() => setActive(!isActive)}
              >
                Active
              </Checkbox>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default UpdateMake;
